import {
  PhoneNumberSchema,
  PhoneNumberUseCase,
} from "@redotech/redo-common-model/phone/phone-number";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/** Every number the team holds for the use case, oldest first. */
export const getPhoneNumbersByTeamIdAndUseCase = {
  name: "getPhoneNumbersByTeamIdAndUseCase" as const,
  input: z.object({
    teamId: z.string(),
    useCase: createEnum(PhoneNumberUseCase),
  }),
  output: z.array(PhoneNumberSchema),
};
